import styles from "./RootLayout.module.scss";

import { Outlet } from "@tanstack/react-router";

import { Copyright } from "@/modules/shared/components/Copyright";
import { Logo } from "@/modules/shared/components/Logo";

/**
 * The header, main and footer that RootLayout renders for standard routes.
 */
export function StandardLayout() {
  return (
    <div className={styles.layout}>
      <header className={styles.header}>
        <Logo />
      </header>
      <main className={styles.main}>
        <Outlet />
      </main>
      <footer className={styles.footer}>
        <Copyright />
      </footer>
    </div>
  );
}
